import listingImage1 from './images/featured_listing_1.png';
import listingImage2 from './images/featured_listing_2.png';
import listingImage3 from './images/featured_listing_3.png';
import avatarImage1 from './images/avatar_1.png';
import avatarImage2 from './images/avatar_2.png';
import avatarImage3 from './images/avatar_3.png';

export const linksProps = {
  listing1: {
    id: '625962e4-7fac-47dc-932c-3781219b004c',
    title: 'Belle piscine, terrasse et jardin avec vue mer, à Toulon',
    price: '1000',
    image: listingImage1,
    provider: {
      // avatar: avatarImage1,
      displayName: 'Mikael M',
      abbreviatedName: 'MM',
    },
  },
  listing2: {
    id: '5d0669fa-93e4-481c-b45e-98974d952e10',
    title: '🌸 La Villa Les Glycines 🌸 - Lieu exceptionnel à 20min de Paris',
    price: '2000',
    image: listingImage2,
    provider: {
      avatar: avatarImage2,
      displayName: 'Helene B',
      abbreviatedName: 'HB',
    },
  },
  listing3: {
    id: '62cd7372-440e-42c8-b0f5-a90719eb59e4',
    title: 'Belle piscine au calme à la campagne (Sud Gironde)',
    price: '1200',
    image: listingImage3,
    provider: {
      avatar: avatarImage3,
      displayName: 'Sebastien V',
      abbreviatedName: 'SV',
    },
  },
};
